import React, { useState, useEffect } from 'react';
import { useLocation, BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from "./pages/LanguageContext";

// Import all pages' components
import Header from './pages/header.js';
import Footer from './pages/footer.js';
import Home from './pages/home.jsx';
import Maintenance from "./pages/Maintenance";
import About from './pages/about.js'; 
//import Category from './pages/category.js';
//import NFTOpenSea from './pages/NFTOpenSea.js';

import TopWhenRefresh from './pages/TopWhenRefresh.jsx';
import SignupModal from './pages/SignupModal.jsx'
import RegisterOperator from './pages/registerOperator.js';
import RequireTourAccess from "./RequireTourAccess";            // route guard for tours
import MyTours from "./pages/myTours.jsx";
import Tour from './pages/tour.jsx';
import Esplorazione from './pages/esplorazione.jsx';
import Tour_google from './pages/tour_google.jsx';
import TourPreview from './pages/tourPreview.jsx';
import FuoriPreview from './pages/FuoriPreview.jsx';
import FuoriRotta from './pages/FuoriRotta.jsx';

import Support from './pages/support.jsx';
import Chatbot from './pages/chatbot.js';
import Profile from './pages/profile.js';
import Partner from './pages/partner.js';
import ContactUs from './pages/contactus.js';
import Choose from './pages/choose.jsx';
import Eventi from './pages/eventi.js';
import Blog from './pages/blog.js';
import Community from './pages/community.js';
import SingleCommunityPage from './pages/SingleCommunityPage.jsx';
import NFT from './pages/NFT.jsx';
import NFTClub from './pages/nftClub.jsx';
import Carrello from './pages/carrello.jsx';
import Pay from './pages/pay.jsx';
import Success from './pages/success.jsx';
import Conditions from './pages/conditions.js';
import NFTconditions from './pages/conditionsNFT.js';
import Privacy from './pages/privacy.js';
import Cookies from './pages/cookies.js';
import InfoLegge from './pages/infolegge.js';
import Legal from './pages/legal.js';
import Questionnaire from './pages/questionnaire.jsx';
import Subscriptions from "./pages/Subscriptions";
import CompleteRegistration from "./pages/CompleteRegistration";
import LandingPage from "./pages/LandingPage.jsx";
import CookieBanner from './pages/CookieBanner.jsx';

import AdminFlights from "./pages/AdminFlights.jsx";
import AdminCruiseSchedule from "./pages/AdminCruiseSchedule.jsx";



import PaySim from "./pages/PaySim";

import TecheSocketDebug from "./pages/TecheSocketDebug";

import PeopleMap from './pages/page.jsx';
import FriendRequests from './pages/Friend.jsx';
import ChatPage from './pages/ChatPage.jsx';
import ChatFloat from './pages/chatFloat.jsx';
import Chat from './pages/chat.jsx';
import DMPage from './pages/DMPage.jsx';


import Login from './pages/login.js';
import Register from './pages/register.jsx';
import Forgotpassword from './pages/forgotpassword.js';
import Resetpassword from './pages/resetpassword.jsx';
import NotFound from "./pages/NotFound";
import './styles/Global.css';





/** Fires Google Ads page-view conversion on every route change (SPA). */
function RouteConversionPinger() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (window.gtag && window.hasAdsConsent) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17507143077/0WkMCPKG-5obEKWbh5xB'
      });
    }
  }, [pathname, search]);

  return null;
}




  function AppShell() {
/*    To create messages between users, we have nodes USER for each user in database neo4j.
    How to do that: 
    1. Add a CHAT node (one per conversation) instead of wiring each MESSAGE directly from A → B.
    2. Each CHAT node will have MESSAGE nodes connected to it, via relationships like HAS_MESSAGE.

    3. Create a relationship from USER A to MESSAGE node called MESSAGED
    3. Create a relationship from MESSAGE node to USER B called MESSAGED
    4. Store message content and timestamp in MESSAGE node properties
    5. properties contents should have time to display each message with its time. To do time for each single message,
       we do same way as whatsapp does. We store time in each message node property and when displaying messages, we check the time property to show time accordingly.
 */   




    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const isLanding = location.pathname.toLowerCase() === "/landingpage";
    const isMessagesPage = location.pathname.toLowerCase() === "/messages";
    const shouldHideShellElements = isLanding;


    const MAINTENANCE = String(process.env.REACT_APP_MAINTENANCE || "0").trim() === "1";

    

useEffect(() => {
  if (MAINTENANCE) {
    setLoading(false);
    return;
  }
  const storedUser = localStorage.getItem("user");
  if (storedUser) setUser(JSON.parse(storedUser));
  const t = setTimeout(() => setLoading(false), 800);
  return () => clearTimeout(t);
}, [MAINTENANCE]);


  
// react to login/logout events from anywhere (e.g., SignupModal)
useEffect(() => {
  const onLogin = (e) => {
  const u = e?.detail || JSON.parse(localStorage.getItem("user"));
  setUser(u || null);
};
  const onLogout = () => setUser(null);
  window.addEventListener("auth:login", onLogin);
  window.addEventListener("auth:logout", onLogout);
  return () => {
    window.removeEventListener("auth:login", onLogin);
    window.removeEventListener("auth:logout", onLogout);
  };
}, []);



/*
              // Prevents drag and right-click on images and videos
              // Also blocks Ctrl+S, Ctrl+U, and Ctrl+P
                useEffect(() => {
                  const handleContextMenu = (e) => {
                    // To prevent any right click just remove the if statment 
                    if (['IMG', 'VIDEO'].includes(e.target.tagName)) {
                      e.preventDefault();
                    }
                  };

                  const handleDragStart = (e) => {
                    if (['IMG', 'VIDEO'].includes(e.target.tagName)) {
                      e.preventDefault();
                    }
                  };

                  const blockKeys = (e) => {
                    const key = e.key.toLowerCase();
                    const ctrlOrMeta = e.ctrlKey || e.metaKey;
                  
                    // Uncomment F12 thing to prevent Open DevTools
                    if ((ctrlOrMeta ) && ['s', 'u', 'p', 'shift', 'i', 'j', 'c'].includes(e.key()) || 
                    (ctrlOrMeta && e.shiftKey && ['i', 'j', 'c', 's', 'p'].includes(key))  ) {            // (e.key === 'F12') 
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  };


                  document.addEventListener('contextmenu', handleContextMenu);
                  document.addEventListener('dragstart', handleDragStart);
                  document.addEventListener('keydown', blockKeys);

                  return () => {
                    document.removeEventListener('contextmenu', handleContextMenu);
                    document.removeEventListener('dragstart', handleDragStart);
                    document.removeEventListener('keydown', blockKeys);
                  };
                }, []);
*/



if (MAINTENANCE) {
  return <Maintenance />;
}


if (loading) {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-white">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
      <p className="mt-4 text-lg font-semibold text-black">Te.C.H-e.</p>
    </div>
  );
}



    
    return (
      <>
        {/*<Router> */}
          <TopWhenRefresh />
          <CookieBanner />
            <div className="App min-h-screen flex flex-col bg-[#F2F2F2] overflow-x-hidden">
              <RouteConversionPinger />  {/* Google Analytics Page View Tracker */}
                {!isLanding  && <Header user={user} />}       {/* Pass user details to the Header */}
                <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home user={user} />} />
                  <Route path="/maintenance" element={<Maintenance />} />
                  <Route path="/about" element={<About user={user} />} />
                  
                  <Route path="/choose" element={<Choose user={user} />} />
                  
                  {/*<Route path="/profile" element={<Profile user={user} />} />*/}
                  <Route path="/profile" element={user ? <Profile /> : <Navigate to="/login" replace />} />
                  <Route path="/partner" element={<Partner user={user} />} />
                  <Route path="/carrello" element={<Carrello user={user} />} />
                  {/*<Route path="/pay" element={<Pay user={user} />} />*/}
                  <Route path="/pay" element={user ? <Pay /> : <Navigate to="/login" replace />} />
                  <Route path="/success" element={<Success user={user} />} />
                  

                  
                  
                  <Route path="/registerOperator" element={<RegisterOperator user={user} />} />
                  <Route path="/SignupModal" element={<SignupModal />} />
                  {/*<Route path="/myTours" element={<MyTours user={user}/>} />*/}
                  <Route path="/myTours" element={user ? <MyTours /> : <Navigate to="/login" replace />} />

                  <Route path="/tour/:tourID" element={<Tour user={user} />} />
                  {/* <Route path="/tour/:tourID" element={<RequireTourAccess> <Tour /> </RequireTourAccess> } />*/}
                  <Route path="/esplorazione/:id" element={<Esplorazione user={user} />} />
                  <Route path="/tour_google/:tourID" element={<Tour_google user={user} />} />
                  <Route path="/tourPreview/:tourID" element={<TourPreview user={user} />} />
                  <Route path="/FuoriPreview/:tourID" element={<FuoriPreview />} />
                  <Route path="/FuoriRotta/:tourID" element={<FuoriRotta />} />
                  
                  <Route path="/support" element={<Support user={user} />} />
                  <Route path="/eventi" element={<Eventi user={user} />} />       
                  <Route path="/blog" element={<Blog user={user} />} />
                  <Route path="/community" element={<Community user={user} />} />
                  <Route path="/community/:id" element={<SingleCommunityPage user={user} />} />
                  <Route path="/nft" element={<NFT user={user} />} />
                  <Route path="/nftClub" element={<NFTClub user={user} />} />
                  <Route path="/carrello" element={<Carrello user={user} />} />
                  <Route path="/contactus" element={<ContactUs />} />
                  <Route path="/conditions" element={<Conditions />} />
                  <Route path="/NFTconditions" element={<NFTconditions />} />

                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/cookies" element={<Cookies />} />
                  <Route path="/infolegge" element={<InfoLegge />} />
                  <Route path="/legal" element={<Legal />} />
                  <Route path="/questionario" element={<Questionnaire />} />
                  <Route path="/subscriptions" element={<Subscriptions />} />
                  <Route path="/CompleteRegistration" element={<CompleteRegistration />} />
                  <Route path="/LandingPage" element={<LandingPage />} />

                  
                  <Route path="/admin" element={<AdminFlights />} />
                  <Route path="/admin-cruise" element={<AdminCruiseSchedule />} />


                  
                  
                  <Route path="/pay-sim" element={<PaySim />} />

                  <Route path="/people" element={user ? <PeopleMap /> : <Navigate to="/login" replace />} />
                  <Route path="/friends" element={user ? <FriendRequests /> : <Navigate to="/login" replace />} />
                  <Route path="/messages" element={user ? <ChatPage /> : <Navigate to="/login" replace />} />
                  <Route path="/dm/:convId" element={user ? <DMPage /> : <Navigate to="/login" replace />} />
                  
                  <Route path="/login" element={user ? <Navigate to="/" /> : <Login setUser={setUser} />} />
                  <Route path="/register" element={user ? <Navigate to="/" /> : <Register />} />
                  <Route path="/forgotpassword" element={user ? <Navigate to="/" /> : <Forgotpassword user={user} />} />
                  <Route path="/resetpassword" element={<Resetpassword />} />

                  
                  
                  <Route path="/404" element={<NotFound />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>




              {   /*  !isLanding && <Chatbot />      */         }
              {!shouldHideShellElements && <ChatFloat />}
              {!isLanding && <Footer />}



            </div>
          
        {/*</Router> */}
      </>
    );
  }

export default function App() {
  return (
    <LanguageProvider>
        <AppShell />
    </LanguageProvider>
  );
}